import FileSaver from "file-saver";
import { Base64Decoder } from "./tool-service";

/**
 * 下載檔案
 *
 * @param file 檔案資料(包含base64字串、檔案名稱、檔案類型)
 * @returns
 */
export const downloadFile = (res,fileName) => {
    const blob = new Blob([res],{
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  });
  FileSaver.saveAs(blob, fileName);


  // 建立一個 Blob 物件,代表要下載的檔案
  // const url = window.URL.createObjectURL(new Blob([res]));
  // // 建立一個 <a> 元素,並將其 href 設置為 Blob 物件的 URL
  // const link = document.createElement('a');
  // link.href = url;
  // // 設置下載檔案的名稱
  // link.setAttribute('download', fileName);
  // // 將 <a> 元素插入到文件中,並模擬點擊以觸發下載
  // document.body.appendChild(link);
  // link.click();
  }

  export const downloadAuditLogFile=(data,fileName)=>{
    let blob = new Blob([Base64Decoder(data)]);
    const reader = new FileReader();
    reader.onloadend = function () {
        // if (window.navigator.msSaveOrOpenBlob) { //IE要使用 msSaveBlob
        //     window.navigator.msSaveBlob(data, fileName)
        // }
        // else {
            const file = new File([blob], fileName);
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        // }
    }
    reader.readAsText(blob);
  }
  